import { render, staticRenderFns } from "./EditKickOffDate.vue?vue&type=template&id=d836768c&"
import script from "./EditKickOffDate.vue?vue&type=script&lang=js&"
export * from "./EditKickOffDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports